import React from "react";
import "./RewardsTickHomePage.scss"
import HeaderText from "../components/Text/HeaderText";
import SubheaderText from "../components/Text/SubheaderText";
const RewardsTickStepsPage = () => {
    const steps = [
        {
            "header": "Sign Up & Shop",
            "subheader": "Create your account and start shopping at your favorite stores through our platform",
            "bgColor": "#059669"
        },
        {
            "header": "Earn Points",
            "subheader": "Automatically earn points and cashback on every purchase you make",
            "bgColor": "#2563EB"
        }, {
            "header": "Redeem Rewards",
            "subheader": "Use your points for discounts, cashback, or exclusive merchandise",
            "bgColor": "#9333EA"
        }
    ]
    const getStepComponents = (step, key) => {
        return (
            <div className="RewardsTickStepsPage-inner-grid-item">
                <div className="RewardsTickStepsPage-inner-grid-item-icon"
                    style={{ background: step?.bgColor }}>{key + 1}</div>
                <div className="RewardsTickStepsPage-inner-grid-item-header">{step?.header}</div>
                <div className="RewardsTickStepsPage-inner-grid-item-subheader">{step?.subheader}</div>

            </div>
        )
    }
    return (
        <div className="RewardsTickStepsPage">
            <div className="RewardsTickStepsPage-inner">
                <HeaderText
                    text={"How RewardsTick Works"} />
                <div className="RewardsTickStepsPage-subheader">
                    <SubheaderText
                        text={"Start earning rewards in three simple steps"}
                    />
                </div>
                <div className="RewardsTickStepsPage-inner-grid">
                    {steps.map((step, key) => {
                        return (getStepComponents(step, key))
                    })
                    }
                </div>
            </div>
        </div>
    )
}
export default RewardsTickStepsPage